import React from 'react';
import { Check, X } from 'lucide-react';
import { evaluatePassword, PASSWORD_STRENGTH_LABELS } from '../lib/passwordStrength';

// Componente reutilizable: barra de fuerza + checklist de reglas.
//
// Props:
//   - password: string evaluado en cada render. Si está vacío, no se pinta
//     nada (devuelve null) para no contaminar el formulario al inicio.
//   - showChecklist (default true): si false, solo pinta la barra (útil
//     en sitios con poco espacio como una previa de Excel).
const PasswordStrengthMeter = ({ password = '', showChecklist = true }) => {
  if (!password) return null;
  const { score, results } = evaluatePassword(password);
  const meta = PASSWORD_STRENGTH_LABELS[score];

  return (
    <div className="mt-2">
      <div className="flex items-center gap-3">
        <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden flex gap-0.5">
          {[0, 1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="flex-1 transition-colors"
              style={{
                backgroundColor: i <= score ? meta.color : 'transparent',
              }}
            />
          ))}
        </div>
        <span
          className="text-[11px] font-bold uppercase tracking-wider tabular-nums"
          style={{ color: meta.color }}
        >
          {meta.label}
        </span>
      </div>

      {showChecklist && (
        <ul className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1">
          {results.map((r) => (
            <li
              key={r.key}
              className={`text-[11px] inline-flex items-center gap-1.5 ${
                r.ok ? 'text-emerald-700' : 'text-ink-muted'
              }`}
            >
              {r.ok ? <Check size={11} /> : <X size={11} className="text-slate-300" />}
              {r.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PasswordStrengthMeter;
